<template>
  <div class="main-form">
    <div v-if="menuInfo" class="page-info">
      <img :src="menuInfo.bgImg" />
    </div>
    <div v-else class="main-form-inner">
      <Card v-for="(item, index) in examForms" :key="item.id" class="form-group">
        <div class="form-item form-title">-----------{{ item.title }}-----------</div>
        <div class="form-item">{{ `${user.group}  ${user.language}` }}</div>
        <div class="form-item" style="margin-top: 16px;"><Button type="primary" @click="handleStartExam(item, index)" :disabled="disabled[index]"
            :loading="loading[index]">{{ item.buttonText }}</Button></div>
        <div class="form-item">开放时间：{{ item.examStartTimeStr }} ~ {{ item.examEndTimeStr }}</div>
      </Card>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { Card, Button } from 'element-ui'
import { parseTime } from '@/utils/format.js';
import { getLoginUrl } from '@/services/noc.js'
export default {
  components: {
    Card,
    Button
  },
  props: {},
  data: () => {
    return {
      loading: [],
      disabled: [],
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.userInfo,
      examList: state => state.user.examList
    }),
    ...mapGetters(['currentCompInfo']),
    currentForms() { // 筛选当前时间段可以显示的form组
      const { forms } = this.currentCompInfo
      const currentForms = []
      forms.forEach((item) => {
        const { timeStart: startTime, timeEnd: endTime, disabled } = item
        const now = new Date().getTime()
        if (now >= new Date(startTime).getTime() && now <= new Date(endTime).getTime() && !disabled) {
          if (item.type === '1') {
            const examInfo = this.examList.find((exam) => exam.exam_id == item.examId)
            if (examInfo) {
              item.examStartTimeStr = parseTime(examInfo.start_time, '{y}-{m}-{d} {h}:{i}')
              let endTimeStr = '永久有效'
              if (examInfo.pattern === 1) { // 集中考试
                if (examInfo.deadline) {
                  endTimeStr = parseTime(examInfo.deadline, '{y}-{m}-{d} {h}:{i}')
                } 
              }
              if (examInfo.pattern === 2) { // 随来随考
                if (examInfo.end_time) {
                  endTimeStr = parseTime(examInfo.end_time, '{y}-{m}-{d} {h}:{i}')
                }
              }
              item.examEndTimeStr = endTimeStr
              item.examInfo = examInfo
            }
          }
          currentForms.push(item)
        }
      })
      return currentForms.reverse()
    },
    examForms() {
      return this.currentForms.filter(item => item.type === '1')
    },
    menuInfo() { // 从 currentForms 中筛选出当前菜单配置
      let menuInfo = null
      this.currentForms.some((item) => {
        if (item.type === '2') {
          menuInfo = item
          return true
        }
      })
      return menuInfo
    }
  },
  methods: {
    handleStartExam(item, index) {
      this.$set(this.loading, index, true)
      getLoginUrl({
        exam_id: item.examId,
        login_param1: this.user.competitorOne,
        login_param2: this.user.compCode
      }).then((res) => {
        this.$set(this.loading, index, false)
        if (res.status_code === 200) {
          const { url, token } = res.data
          let newUrl = url + '&token=' + token
          if (newUrl.indexOf('http') !== 0) {
            newUrl = '//' + newUrl
          }
          window.open(newUrl)
        } else {
          this.$message.showMessage({info: res.msg || res.message})
        }
      }).catch((error) => {
        this.$set(this.loading, index, false)
        this.$message.showMessage({info: error.data ? error.data.message : error.statusText || '获取考试链接失败'})
      })
    },
    // 判断当前时间是否在考试时间内,动态修改按钮点击状态
    handleTimeCheck() {
      const now = new Date().getTime()
      const disabled = []
      this.examForms.forEach((item, index) => {
        const { examInfo } = item
        const {
          start_time: startTime, // 考试开始时间
          end_time: endTime, // 针对随来随考 考试截止进入时间 0-永久有效
          deadline, // 针对集中考试 考试结束时间
          pattern, // 考试模式 1.集中考试 2.随来随考
          waiting_time_enabled: waitingTimeEnabled, // 提前候考是否开启 false-未开启 true-开启
          waiting_time: waitingTime // 候考时间 (分钟)
        } = examInfo
        const start = waitingTimeEnabled ? startTime - waitingTime * 60 * 1000 : startTime
        const end = pattern === 1 ? deadline : endTime
        if (now >= start && (end === 0 || now <= end)) {
          disabled[index] = false
        } else {
          disabled[index] = true
        }
      })
      this.disabled = disabled
    },
    handleTimeCheckInterval() {
      this.handleTimeCheck()
      this.timer = setInterval(() => {
        this.handleTimeCheck()
      }, 1000)
    }
  },
  mounted () {
    this.handleTimeCheckInterval()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less" scoped>
.main-form {
  width: 100%;
  height: calc(100% - 64px);
  &-inner {
    width: 80%;
    min-height: calc(100% - 125px);
    box-sizing: border-box;
    background-color: #fff;
    margin: 50px 0 70px;
    display: inline-block;
    border-radius: 5px;
    box-shadow: 0 0 5px #ddd;
    padding: 20px;
    position: relative;
  }
  .form-group {
    text-align: center;
    background-color: #f0f4fc;
    margin-bottom: 20px;
  }
  .form-item {
    margin: 5px 0;
  }
  .form-title {
    font-size: 20px;
    font-weight: 600;
  }
}

</style>